module.exports = __webpack_public_path__ + "img/beer_id-112.046d781b.png";